import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Footer from '../components/Footer';
import NextMatchesSection from '../components/NextMatchesSection';

const HomePage = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header scrollY={scrollY} />
      <Hero />

      <NextMatchesSection />

      {/* Welcome Section */}
      <section className="py-20 bg-gradient-to-br from-green-50 via-white to-emerald-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Features Grid */}
          <div className="grid md:grid-cols-2 gap-8">
            {/* Courts de tennis synthétiques */}
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all hover:scale-105">
              <div className="flex items-start gap-4">
                <div className="text-5xl">🟢</div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    2 Courts de tennis synthétiques !
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    Jouez presque par tous les temps, dès que le soleil se fait sentir&nbsp;!
                  </p>
                </div>
              </div>
            </div>

            {/* Nouveau terrain de padel */}
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all hover:scale-105">
              <div className="flex items-start gap-4">
                <div className="text-5xl">🟠</div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    1 Terrain de padel extérieur
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    Idéal pour s'initier ou se perfectionner dans ce sport dynamique.
                  </p>
                </div>
              </div>
            </div>

            {/* Mini-court gratuit */}
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all hover:scale-105">
              <div className="flex items-start gap-4">
                <div className="text-5xl">⚡</div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    Mini-court gratuit
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    Pour les jeunes… et les moins jeunes qui veulent s'amuser !
                  </p>
                </div>
              </div>
            </div>

            {/* Club-house rénové */}
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all hover:scale-105">
              <div className="flex items-start gap-4">
                <div className="text-5xl">☕</div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    Club-house rénové
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    Un lieu chaleureux pour se détendre après l'entraînement ou pendant les cours juniors.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
